module.exports = __webpack_public_path__ + "static/media/lifeline_step_8_neg.6c443a9a.png";